












import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import { TextInput, Field } from '@alpha/ink'
import Redactor from '@/components/Redactor.vue'

@Component({
  components: {
    TextInput,
    Redactor,
    Field
  }
})
export default class AddProjectModal extends Vue {
  @Prop() readonly workspaceId!: string
  @Prop({ default: '' }) projectId!: string
  @Prop({ default: '' }) projectTitle!: string
  @Prop({ default: '' }) projectDescription!: string
  @Prop({ default: '' }) titleError!: string | null

  title = this.projectId ? this.projectTitle : ''
  description = this.projectId ? this.projectDescription : ''

  get payload () {
    return {
      title: this.title,
      description: this.description
    }
  }

  @Watch('payload', { deep: true })
  changes () {
    this.$emit('change', this.payload)
  }
}
